import React from 'react';
import PropTypes from 'prop-types';

import {currentResource, labels} from '../../../../../../../util/utils';
import {colorOptions} from './utils/constants';

import TagLabel from '../../../../../../Common/TagLabel';
import ReactSelect from '../../../../../../CoreWrappers/ReactSelect';

const TagsSelect = ({value, onChange, disabled, showError}) => {
	const options = colorOptions
		.filter((x) => !x.ignore)
		.map(({value}) => ({
			id: value,
			value,
			label: currentResource.colorOptionsLabels[value.toLowerCase()]
		}));

	const handlerOnSelectChange = (newValue) => {
		onChange && onChange(newValue);
	};

	const renderCustomOption = ({value, label}) => {
		const props = {
			variant: value?.toLowerCase(),
			text: label
		};

		return <TagLabel {...props} key={value} />;
	};

	const props = {
		id: 'colorSelect',
		formLabel: labels.color,
		defaultValue: value === '' ? null : colorOptions.find((x) => x.value === value),
		value: value === '' ? null : colorOptions.find((x) => x.value === value),
		onChange: handlerOnSelectChange,
		options,
		isDisabled: disabled,
		maxOptionsBeforeScroll: 5,
		errorMessage: labels.required,
		showErrorMessage: showError,
		formatOptionLabel: renderCustomOption
	};

	return <ReactSelect {...props} />;
};

TagsSelect.propTypes = {
	disabled: PropTypes.bool,
	value: PropTypes.string,
	onChange: PropTypes.func
};

export default TagsSelect;
